<template>
  <BaseDialog
    v-model="showDialog"
    :title="title"
    :subtitle="subtitle"
    :dialogIcon="icon"
    btnActionName="Opprett"
    @action="add"
  >
    <template v-slot>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-autocomplete
          v-model="project"
          :items="projects"
          filled
          label="Velg prosjekt"
          item-text="name"
          item-value="id"
          :rules="[(v) => !!v || 'Prosjekt må velges!']"
          @change="changeProject"
        ></v-autocomplete>

        <v-select
          v-model="house"
          :items="houses"
          filled
          label="Velg bygg"
          item-text="name"
          item-value="id"
          :disabled="!project"
          @change="changeHouse"
        ></v-select>

        <v-select
          v-model="section"
          :items="sections"
          filled
          label="Velg seksjon"
          item-text="displayName"
          item-value="id"
          :disabled="!project || !house"
        ></v-select>

        <v-autocomplete
          v-model="checklist"
          :items="getChecklists"
          filled
          label="Velg sjekkliste"
          item-text="value"
          item-value="key"
          :rules="[(v) => !!v || 'Sjekkliste må velges!']"
          :disabled="!project"
        ></v-autocomplete>

        <v-autocomplete
          v-model="assignedTo"
          :items="users"
          filled
          label="Ansvarlig"
          item-text="value"
          item-value="key"
          :rules="[(v) => !!v || 'Ansvarlig må velges!']"
        ></v-autocomplete>

        <DatePickerDialog
          v-model="deadline"
          label="Frist"
          :min="moment().format()"
          :rules="[(v) => !!v || 'Frist må velges!']"
        />
      </v-form>
    </template>
  </BaseDialog>
</template>

<script lang="ts">
interface checklistsObject {
  availableChecklistsHouse: any;
  availableChecklistsProject: any;
  availableChecklistsSection: any;
}

import Vue from "vue";
import { mapGetters } from "vuex";
import moment from "moment";
import projectApi from "@/api/projectApi";
import checkListApi from "@/api/checkListApi";

import BaseDialog from "@/components/shared/dialog/BaseDialog.vue";
import DatePickerDialog from "@/components/shared/date/DatePickerDialog.vue";

export default Vue.extend({
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    title: {
      type: String,
    },
    subtitle: {
      type: String,
    },
    icon: {
      type: String,
    },
    users: {
      type: Array,
    },
    projectId: {
      type: [Number || null],
    },
  },
  data() {
    return {
      valid: true,
      project: null as any,
      house: null,
      section: null as any,
      checklist: null,
      assignedTo: null,
      deadline: null,
      projects: [],
      houses: [],
      sections: [],
      checklists: {} as checklistsObject,
      moment,
    };
  },
  watch: {
    value(newValue: boolean, oldValue: boolean) {
      if (newValue && !oldValue) {
        this.fetch();
      }
      if (!newValue) {
        (this as any).$refs.form.reset();
      }
    },
  },
  methods: {
    fetch() {
      this.assignedTo = this.profile.id ? this.profile.id : null;
      this.project = this.projectId ? this.projectId : null;
      this.house = null;
      this.section = null;
      this.getProjects();
    },
    async getProjects() {
      projectApi.getProjects(false).then((response) => {
        this.projects = response.projects;
      });

      if (this.project) {
        this.changeProject();
      }
      if (this.project && this.house) {
        this.changeHouse(true);
      }
    },
    async changeProject() {
      if (this.project) {
        await checkListApi
          .getChecklistsProjects(this.project)
          .then((response) => {
            this.checklists = response;
          });

        await projectApi
          .getProjectHouses(this.project, false)
          .then((response) => {
            var test = [{ id: null, name: "Ingen valgt" }];
            this.houses = [...test, ...response] as any;
          });
      }
    },
    async changeHouse(saveSection = false) {
      if (!saveSection) {
        this.section = null;
      }

      if (this.project && this.house) {
        await projectApi
          .getProjectSections(this.project, false)
          .then((response) => {
            var test = [{ id: null, displayName: "Ingen valgt" }];
            var sectionsFiltered = response.filter(
              (x) => x.houseId === this.house
            );
            this.sections = [...test, ...sectionsFiltered] as any;
          });
      }
    },
    add() {
      var valid = (this as any).$refs.form.validate();
      if (valid) {
        var contextId = null;
        var context = 0;
        if (this.section) {
          contextId = this.section;
          context = 3;
        } else if (this.house) {
          contextId = this.house;
          context = 2;
        } else if (this.project) {
          contextId = this.project;
          context = 1;
        }

        var data = {
          checklistId: this.checklist,
          contextId: contextId,
          context: context,
          parentCheckList: this.checklist,
          assignedTo: this.assignedTo,
          deadLine: this.deadline,
        };

        checkListApi.generateChecklist(data).then((r) => {
          this.$router.push({ name: "checklist", params: { id: r.id } });
        });
      }
    },
  },
  computed: {
    ...mapGetters({
      profile: "shared/profile",
    }),
    showDialog: {
      get(): boolean {
        return this.value;
      },
      set(value: boolean) {
        this.$emit("input", value);
      },
    },
    getChecklists(): Array<any> {
      if (this.section) {
        return this.checklists.availableChecklistsSection;
      } else if (this.house) {
        return this.checklists.availableChecklistsHouse;
      } else if (this.project) {
        return this.checklists.availableChecklistsProject;
      }
      return [];
    },
  },
  components: {
    BaseDialog,
    DatePickerDialog,
  },
});
</script>
